import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { AutocompleteTemplate } from 'common/module/autocomplete/template';
import { BuildingReviewLandingFormTemplatePropsInterface } from 'common/module/building-review-landing/form/template-props.interface';
import { preactDynamicComponent } from 'common/module/preact/dynamic/component';
import { BuildingReviewLandingAutocompleteService } from 'desktop/service/building-review-landing-autocomplete/service';

const Autocomplete = preactDynamicComponent(AutocompleteTemplate);

export const BuildingReviewLandingFormTemplate: FunctionalComponent<BuildingReviewLandingFormTemplatePropsInterface> = (
  props
) => (
  <form className='building-review-landing__form-area' onSubmit={props.onSubmitForm}>
    <div className='building-review-landing__autocomplete-area'>
      <div
        className={`
        building-review-landing__autocomplete
        ${props.showError ? 'building-review-landing__autocomplete--error' : ''}
      `}
      >
        <Autocomplete viewStore={BuildingReviewLandingAutocompleteService()} />
      </div>
      {props.showError && (
        <div className='tooltip2 tooltip2--bottom building-review-landing__tooltip'>
          <div className='tooltip2__content tooltip2__content--style1'>
            {i18nTranslate('Please select building first')}
          </div>
        </div>
      )}
    </div>
    <button className='button building-review-landing__form-button'>{i18nTranslate('See reviews')}</button>
  </form>
);
